module.exports = __webpack_public_path__ + "img/topindicator5.a6bddb03.png";